import React, { Component } from 'react';
import { Link, Route, Redirect } from 'react-router-dom';
import { Button, Col, Form, Label, Input, Row } from 'reactstrap';
import Api from './Api';
import Auth from './Auth';
import './CheckIn.css';

class ChooseCheckInMethod extends Component {

  render() {
    return (
      <div id="choose_checkin_method">
        <h1>Hi! Who is it?</h1>
        <p>Check in using one of the following:</p>
        <ul>
          <li><a href={Api.getFacebookLoginUrl()}>Login with Facebook</a> <span className="text-muted">(recommended)</span></li>
          <li><Link to="/checkin/email">Email</Link></li>
          <li><Link to="/checkin/text">Text Message</Link></li>
        </ul>
        <p>(This is a one-time thing. Your computer or phone will remember you next time you visit.)</p>
      </div>
    );
  }
}

class CheckInViaEmail extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = { email: '' };
  }

  checkEmailAddress = (e) => {
    e.preventDefault();
    Api.sendEmailConfirmation(this.state.email);
    this.setState({
      submitted: true,
    });
  }

  render() {
    if (this.state.submitted) {
      return (
        <Redirect
          push={true}
          to={{
            pathname: '/checkin/confirmemail',
            state: {
              email: this.state.email,
            },
          }}
        />
        );
    }

    return (
      <div id="check_email">
        <h1>Check in via email</h1>
        <p>Be sure to use the email address of yours that we know.</p>
        <Row className="mb-3">
          <Col>
            <Form inline onSubmit={this.checkEmailAddress}>
              <Label for="email_input" hidden>Email</Label>
              <Input ref="email" autoFocus={true} className="mr-3" id="email_input" type="email" placeholder="Email address" onChange={e => this.setState({email: e.target.value})} value={this.state.email}/>
              <Button type="submit" color="primary">Check</Button>
            </Form>
          </Col>
        </Row>
        <p>You will receive a link in your email to finish checking in.</p>
      </div>
    );
  }
}

class ConfirmEmail extends Component {

  render() {
    const { email } = this.props.location.state || {};
    if (!email) {
      return <Redirect to="/checkin/email"/>;
    }

    return (
      <div id="email_sent">
        <h1>Check your email</h1>
        <p>If <span className="email_address">{this.props.location.state.email}</span> is in our list, we just sent you an email with a link to finish checking in.</p>
        <p>If you never receive an email, try one of the other check-in methods, or get in touch with one of us and we'll figure it out.</p>
      </div>
    );
  }
}

class CheckInViaTextMessage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      phoneNumber: '',
      status: '',
    };
  }

  checkPhoneNumber = (e) => {
    this.setState({
      status: 'submitting',
    });
    e.preventDefault();
    Api.sendSmsConfirmation(this.state.phoneNumber)
      .then(result => {
        this.setState({
          status: '',
          error: result.error && 'Make sure your phone number is correct.'
        });
        if (result.actual) {
          this.setState({
            status: 'submitted',
            phoneNumber: {
              actual: result.actual,
              display: result.display,
            },
          })
        }
      });
  }

  render() {
    if (this.state.status === 'submitted') {
      return <Redirect
        push={true}
        to={{
          pathname: '/checkin/confirmtext',
          state: {
            phoneNumber: this.state.phoneNumber,
          },
        }}/>;
    }
    return (
      <div id="check_phone">
        <h1>Check in via text message</h1>
        <p>Be sure to use the phone number of yours that we know.</p>
        <Row className="mb-3">
          <Col>
            <Form inline onSubmit={this.checkPhoneNumber}>
              <Label for="phone_number_input" hidden>Cell #:</Label>
              <Input ref="phoneNumber" autoFocus={true} className="mr-3" type="tel" id="phone_number_input" placeholder="Cell #" onChange={e => this.setState({phoneNumber:e.target.value})} value={this.state.phoneNumber}/>
              <Button color="primary" type="submit" disabled={this.state.status === 'submitting'}>Check</Button>
            </Form>
          </Col>
        </Row>
        <p className="checkin_error">{this.state.error}</p>
        <p>You will receive a code via text message to finish signing in.</p>
      </div>
    );
  }
}

class ConfirmTextMessage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      verifyCode: '',
    };
  }

  verifySmsCode = (e) => {
    e.preventDefault();
    this.setState({
      checking: true,
    });
    Api.confirmSms(this.props.location.state.phoneNumber.actual, this.state.verifyCode)
      .then(result => {
        this.setState({
          checking: false,
          error: result.error && "Please try again.",
        });
        if (result.token) {
          Auth.setAuthToken(result.token);
          this.setState({ redirectToReferrer: true });
        }
      })
  }

  render() {
    if (this.state.redirectToReferrer) {
      const from = this.props.location.state.from || { pathname: '/' };
      return <Redirect to={from}/>;
    }

    const { phoneNumber } = this.props.location.state || {};
    if (!phoneNumber) {
      return <Redirect to="/checkin/text"/>;
    }

    return (
      <div id="text_sent">
        <h1>Check your text messages</h1>
        <p>If <span className="phone_number">{this.props.location.state.phoneNumber.display}</span> is in our list, we just texted you a code. Enter it here to finish checking in.</p>
        <Row className="mb-3">
          <Col>
            <Form inline onSubmit={this.verifySmsCode}>
              <Label hidden for="verify_code">Code:</Label>
              <Input ref="verifyCode" autoFocus={true} className="mr-3" id="verify_code" placeholder="Code" onChange={e => this.setState({verifyCode: e.target.value})} value={this.state.verifyCode}/>
              <Button color="primary" type="submit">Confirm</Button>
            </Form>
          </Col>
        </Row>
        <p className="checkin_error">{this.state.error}</p>
        <p>If you never receive a text message, try one of the other check-in methods, or get in touch with one of us and we'll figure it out.</p>
      </div>
      );
  }
}

const CheckIn = ({ match }) => (
  <div id="checkin">
    <Route path={`${match.url}/email`} component={CheckInViaEmail}/>
    <Route path={`${match.url}/text`} component={CheckInViaTextMessage}/>
    <Route path={`${match.url}/confirmemail`} component={ConfirmEmail}/>
    <Route path={`${match.url}/confirmtext`} component={ConfirmTextMessage}/>
    <Route exact path={match.url} component={ChooseCheckInMethod}/>
  </div>
);

export default CheckIn;



// WEBPACK FOOTER //
// ./src/CheckIn.js